if (!customElements.get("content-spot")) {
  customElements.define(
    "content-spot",
    class ContentSpot extends HTMLElement {
      connectedCallback() {
        this.handleVideoPlay();
      }

      handleVideoPlay() {
        const videos = this.querySelectorAll("video");
        if (videos.length === 0) return;

        if (videos.length === 1) {
          this.observVideo(videos[0]);
        } else {
          const matchesBreakpoint = (video) =>
            (window.innerWidth >= 1024 && video.classList.contains("video-desktop")) ||
            (window.innerWidth < 1024 && video.classList.contains("video-mobile"));

          videos.forEach((video) => {
            if (matchesBreakpoint(video)) {
              this.observVideo(video);
            }
          });
        }
      }

      observVideo(video) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                video.play();
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.75 },
        );

        observer.observe(video);
      }
    },
  );
}
